const industries = [
  "Travel", "Education", "Real Estate", "Coaches & Consultants",
  "Local Businesses", "Startups", "D2C Brands", "E-commerce", "Service-Based Businesses",
];

export default function Industries() {
  return (
    <section className="bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28">
        <div className="max-w-3xl reveal">
          <div className="text-xs font-bold uppercase tracking-widest text-blue-600">Industries</div>
          <h2 className="mt-3 font-display text-3xl md:text-5xl font-bold text-slate-900 tracking-tight">
            Trusted across industries.
          </h2>
        </div>

        <div className="mt-12 flex flex-wrap gap-3 reveal">
          {industries.map((ind, i) => (
            <span
              key={ind}
              data-testid={`industry-${i}`}
              className="inline-flex items-center px-5 py-3 rounded-full border border-slate-200 bg-slate-50 hover:bg-blue-50 hover:border-blue-200 hover:text-blue-700 text-slate-700 text-sm font-medium transition-colors"
            >
              {ind}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
